import { render } from "./a-video-modal.vue?vue&type=template&id=5c8f39fa"
import script from "./a-video-modal.vue?vue&type=script&lang=js"
export * from "./a-video-modal.vue?vue&type=script&lang=js"

import exportComponent from "/opt/bitnami/apps/ocmsta/subdomains/academy/htdocs/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__